import { writable } from 'svelte/store';

const createModalStore = () => {
  const { subscribe, set, update } = writable({
    isAnyModalOpen: false,
    activeModals: new Set()
  });

  return {
    subscribe,
    openModal: (modalId) => update(state => ({
      isAnyModalOpen: true,
      activeModals: state.activeModals.add(modalId)
    })),
    closeModal: (modalId) => update(state => {
      state.activeModals.delete(modalId);
      return {
        isAnyModalOpen: state.activeModals.size > 0,
        activeModals: state.activeModals
      };
    }),
    closeAll: () => set({
      isAnyModalOpen: false,
      activeModals: new Set()
    })
  };
};

export const modalStore = createModalStore(); 